import { prefixObjectValues } from '../../utils';
const form = {
  compType: 'comp-type',
  pricePerHour: 'price-per-hour',
  pricePerShift: 'price-per-shift',
  pricePerRvu: 'price-per-rvu',
  yearlyRvusPerFte: 'yearly-rvus-per-fte',
};
export default prefixObjectValues(form, 'compensation-form');
